import React from 'react';
import { Box, Typography } from '@mui/material';
import { Person } from '@mui/icons-material';

interface UploadByProps {
  uploadBy: string;
}

/**
 * Displays uploader name with icon.
 */
export const UploadBy: React.FC<UploadByProps> = ({ uploadBy }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.5 }}>
    <Person sx={{ fontSize: 14, color: '#64748b' }} />
    <Typography variant="body2" sx={{ fontSize: '0.875rem' }}>
      {uploadBy}
    </Typography>
  </Box>
);

/** Syncfusion grid template wrapper */
export const uploadByTemplate = (props: { uploadBy: string }) => (
  <UploadBy uploadBy={props.uploadBy} />
);

export default UploadBy;
